export default __webpack_public_path__ + "static/BrandonGrotesque-Medium-d7d2670eeea1e3444076dcafc141fd3e.woff2";